import { Component, inject } from '@angular/core';
import { LocaleService } from '@next/core-lib/i18n';
import { SwUpdate } from '@angular/service-worker';
import { NavigationItem } from '@next/core-lib/navigation';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: false,
})
export class AppComponent {
    private readonly locale = inject(LocaleService);
  private readonly serviceWorkerUpdate = inject(SwUpdate);


  direction$ = this.locale.direction$;
  constructor() {
    this.checkWithServiceWorkerForNewVersion();
  }

  checkWithServiceWorkerForNewVersion = async () => {
    try {
      // Check if Service Worker is supported by the Browser
      if (this.serviceWorkerUpdate.isEnabled) {
        // Check if new version is available
        const isNewVersion = await this.serviceWorkerUpdate.checkForUpdate();
        if (isNewVersion) {
          // Check if new version is activated
          const isNewVersionActivated = await this.serviceWorkerUpdate.activateUpdate();

          // Reload the application with new version if new version is activated
          if (isNewVersionActivated) {
            window.location.reload();
          }
        }
      }
    } catch (error) {
      console.log(
        'Service Worker - Error when checking for new version of the application: ',
        error,
      );
      window.location.reload();
    }
  };

  navigationItems: NavigationItem[] = [
    {
      relativeUrl: '/',
      label: 'templates',
      icon: 'start',
    },
    {
      relativeUrl: '/control-room',
      label: 'controlRoom.title',
      icon: 'dashboard',
    },
    {
      relativeUrl: '/nutrient-properties',
      label: 'nutrientProperties.title',
      icon: 'dashboard',
    },
    {
      relativeUrl: '/variety-properties',
      label: 'varietyProperties.title',
      icon: 'dashboard',
    },
    {
      relativeUrl: '/nitrogen-model-properties',
      label: 'nitrogenModelProperties.title',
      icon: 'dashboard',
    },
    {
      relativeUrl: '/production-purpose-category',
      label: 'productionPurposeCategory.title',
      icon: 'dashboard',
    },
  ];
}
